import React, { useState } from 'react';
import { Plus, X } from 'lucide-react';

// Multi-select checklist of pill options with the ability to add/remove custom values.
// value: string[] ; onChange(next: string[])
export function TagChecklist({ label, options = [], value = [], onChange, allowCustom = true, testIdPrefix = 'tag' }) {
    const [custom, setCustom] = useState('');
    // Merge defaults + any selected custom values (preserve order: defaults first, then extra selected)
    const extras = value.filter((v) => !options.includes(v));
    const all = [...options, ...extras];

    const toggle = (opt) => {
        if (value.includes(opt)) onChange(value.filter((v) => v !== opt));
        else onChange([...value, opt]);
    };

    const addCustom = () => {
        const v = custom.trim();
        if (!v) return;
        if (!value.includes(v)) onChange([...value, v]);
        setCustom('');
    };

    return (
        <div data-testid={`${testIdPrefix}-checklist`}>
            {label && <label className="eyebrow block mb-2">{label}</label>}
            <div className="flex flex-wrap gap-2">
                {all.map((opt) => {
                    const active = value.includes(opt);
                    const isExtra = !options.includes(opt);
                    return (
                        <button
                            key={opt}
                            type="button"
                            onClick={() => toggle(opt)}
                            data-testid={`${testIdPrefix}-option-${opt.replace(/\s+/g, '-').toLowerCase()}`}
                            className="px-3 py-1.5 rounded-lg text-xs border inline-flex items-center gap-1.5 transition-colors"
                            style={{
                                borderColor: active ? 'var(--brand-burgundy)' : 'rgba(90,36,50,0.18)',
                                backgroundColor: active ? 'var(--brand-burgundy)' : '#fff',
                                color: active ? '#fff' : 'var(--ink)',
                            }}
                        >
                            {opt}
                            {active && isExtra && <X className="w-3 h-3 opacity-80" />}
                        </button>
                    );
                })}
            </div>
            {allowCustom && (
                <div className="mt-2 flex gap-2">
                    <input
                        value={custom}
                        onChange={(e) => setCustom(e.target.value)}
                        onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); addCustom(); } }}
                        data-testid={`${testIdPrefix}-custom-input`}
                        placeholder="Add custom..."
                        className="input-luxury flex-1 text-sm py-2"
                    />
                    <button
                        type="button"
                        onClick={addCustom}
                        data-testid={`${testIdPrefix}-custom-add`}
                        className="px-3 py-2 rounded-lg border border-[rgba(90,36,50,0.18)] text-xs inline-flex items-center gap-1 hover:bg-[var(--brand-rose)]/40"
                    >
                        <Plus className="w-4 h-4" /> Add
                    </button>
                </div>
            )}
        </div>
    );
}
